"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import { Link } from 'react-router-dom';
import teamImg1 from '../../../assets/images/rrc/team/Shaun.png';
import teamImg2 from '../../../assets/images/rrc/team/pam3.jpg';
import teamImg3 from '../../../assets/images/rrc/team/JM.png';

export default function TeamOne() {
  // State for dynamic content
  const [teamContent] = useState({
    tagline: "Our Team",
    title: "The Crew Behind The Riots",
    members: [
      {
        id: 1,
        name: "Xian",
        role: "Vice President",
        image: teamImg1,
        link: "/team-details",
      },
      {
        id: 2,
        name: "Pam",
        role: "President",
        image: teamImg2,
        link: "/team-details",
      },
      {
        id: 3,
        name: "JM",
        role: "Public Relations",
        image: teamImg3,
        // hoverText:
        //   "Events bring people together for shared experiences and celebrations. From weddings and birthdays to conferences and festivals, events create memories.",
        link: "/team-details",
      },
    ],
  });

  return (
    <>
      {/* Team One Start */}
      <section id="th-team" className="team-one">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">{teamContent.tagline}</span>
            </div>
            <h2 className="section-title__title">
              {teamContent.title.split(" & ").map((text, index) => (
                <span key={index}>
                  {text}
                  <br />
                </span>
              ))}
            </h2>
          </div>
          <div className="row">
            {teamContent.members.map((member, index) => (
              <div
                key={member.id}
                className={`col-xl-4 col-lg-6 wow fadeIn${
                  index === 0 ? "Left" : index === 1 ? "Up" : "Right"
                }`}
                data-wow-delay={`${(index + 1) * 100}ms`}
              >
                <div className="team-one__single">
                  <div className="team-one__img-box">
                    <div className="team-one__img">
                      <img src={member.image} alt={member.name} />
                      <div className="team-one__content">
                        <h4 className="team-one__name">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title">{member.role}</p>
                      </div>
                      <div className="team-one__content-hover">
                        <h4 className="team-one__name-hover">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title-hover">{member.role}</p>
                        <p className="team-one__text-hover">{member.hoverText}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* <div className="flex justify-center items-center h-screen">
              <Link
                style={{ width: '100%', textAlign: 'center' }}
                target="_blank"
                to="https://forms.gle/JhC2UMtjJ8jjAR7X7"
                className="main-slider__btn thm-btn"
              >
                VIEW ALL
              </Link>
            </div> */}



          </div>
        </div>
      </section>
      {/* Team One End */}
    </>
  );
}
